export enum ShapeTypeEnum {
  Rectangle = 0,
  HalfMoon = 1,
  Mushroom = 2,
  Angle = 3,
  Circle = 4,
}
